import { Box, CircularProgress, Stack } from '@mui/material';
import { t } from 'i18next';
import { useEffect } from 'react';
import { Button } from '../index';
import { Card } from '../';
import styles from './ControlCodeBase.module.css';

interface ControlCodeBaseProps {
  authMethod: string;
  isDeviceLink: boolean;
  controlCode: string;
  onCancel: () => void;
}

export const ControlCodeBase = ({ authMethod, isDeviceLink, controlCode, onCancel }: ControlCodeBaseProps) => {
  useEffect(() => {
    return () => {
      const errorContainer: HTMLDivElement | null = document.querySelector('.inline-notification-error');
      const continueButton: HTMLButtonElement | null = document.querySelector('button[type=submit]');

      if (errorContainer) {
        /* Move focus to error message for screenreaders */
        errorContainer.focus();
      } else if (continueButton) {
        /* Move focus to form CTA button */
        continueButton.focus();
      }
    };
  }, []);

  return (
    <div className={styles.cardContainer}>
      <Card>
        <Stack
          className={styles.codeContainer}
          direction="column"
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
          <Stack
            className={styles.codeContainerInner}
            {...{ 'aria-live': 'polite', tabIndex: 0 }}
            sx={{
              alignItems: 'center',
              gap: 1
            }}>
            {
              isDeviceLink ? (
                <span>{t('form.sid.DeviceLink.RunningDescription')}</span>
              ) : (
                <>
                  {!controlCode.length && (
                    <span className="screenreader-text">{t('form.screenreader.waitingVerificationCode')}</span>
                  )}

                  {controlCode.length > 0 && (
                    <>
                      <span>{t(`form.${authMethod}.confirmedTitle`)}</span>

                      <span {...{ 'data-testid': 'yourControlCode' }}>{t(`form.${authMethod}.yourCodeIs`)}:</span>
                    </>
                  )}

                  <span style={{ fontSize: '64px', fontWeight: '300' }}>
                    {controlCode.length > 0 ? (
                      <span>{controlCode}</span>
                    ) : (
                      <span aria-label={t('form.screenreader.verificationCodePlaceholder')}>_ _ _ _</span>
                    )}
                  </span>
                </>
              )
            }

            <Box sx={{
              my: 2
            }}>
              <CircularProgress aria-label="Spinner" size={80} color="primary"></CircularProgress>
            </Box>
          </Stack>

          <Button
            appearance="text"
            size="m"
            color="outline"
            onClick={onCancel}
            {...{ 'data-testid': 'controlCodeCancel' }}
          >
            {t('form.general.back')}
          </Button>
        </Stack>
      </Card>
    </div>
  );
};
